import { ExtractPropTypes, PropType } from 'vue'
import { InputProps as WxInputProps } from '@tarojs/components'
// import {FormItem} from '@nutui/nutui-taro'

export const customNumberInputProps = {

  /* 值 */
  modelValue: {
    type: [String, Number],
    default: '',
  },

  /* 文本对齐 */
  textAlign: {
    type: String as PropType<'left' | 'right' | 'center'>,
    default: 'center',
  },

  /* 最大长度(字符串截断用) */
  maxLength: {
    type: Number,
    default: 999,
  },

  /* 最大值 */
  max: {
    type: Number,
    default: Infinity,
  },

  /* 最小值 */
  min: {
    type: Number,
    default: 1,
  },

  // 是否限制大于0
  gZero: {
    type: Boolean,
    default: true
  }
}

export type CustomNumberInputProps = Partial<ExtractPropTypes<typeof customNumberInputProps>> & WxInputProps